module.exports = __webpack_public_path__ + "img/bth_bed2_left_beibu_sel.b2192db2.png";